import { createAction, props } from '@ngrx/store';
import { IEarlyAccessLaunchStatus } from '../../service/early-access/interface';
import { IResponseError } from '../../service/interface';

// ── API ──

const loadLaunchStatus = createAction('[EarlyAccess/API] Load Launch Status');

const loadLaunchStatusSuccess = createAction(
	'[EarlyAccess/API] Load Launch Status Success',
	props<{ launchStatus: IEarlyAccessLaunchStatus }>(),
);

const loadLaunchStatusError = createAction(
	'[EarlyAccess/API] Load Launch Status Error',
	props<{ error: IResponseError }>(),
);

const sendLaunch = createAction('[EarlyAccess/API] Send Launch');

const sendLaunchSuccess = createAction('[EarlyAccess/API] Send Launch Success');

const sendLaunchError = createAction(
	'[EarlyAccess/API] Send Launch Error',
	props<{ error: IResponseError }>(),
);

// ── UI ──

const clearError = createAction('[EarlyAccess/UI] Clear Error');

export const EarlyAccessActions = {
	loadLaunchStatus,
	loadLaunchStatusSuccess,
	loadLaunchStatusError,
	sendLaunch,
	sendLaunchSuccess,
	sendLaunchError,
	clearError,
};
